import React from 'react';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center font-bold rounded-full transition-all duration-300 ease-out overflow-hidden group';
  const variants = {
    primary: 'bg-accent text-white hover:bg-accent-dark shadow-[0_0_15px_rgba(39,174,96,0.4)] hover:shadow-[0_0_25px_rgba(39,174,96,0.6)] hover:-translate-y-1 border border-accent-light/30',
    secondary: 'glass text-white hover:bg-white/10 shadow-sm hover:shadow-md'
  };
  const sizes = 'py-4 px-6 text-base md:text-lg leading-tight';
  const width = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes} ${width} ${className}`} {...props} data-id="element-345">
      <span className="relative z-10 flex items-center justify-center gap-2 text-center" data-id="element-346">
        {children}
        {variant === 'primary' && <ChevronRight className="w-5 h-5 flex-shrink-0 transition-transform group-hover:translate-x-1" data-id="element-347" />}
      </span>
      {variant === 'primary' && <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out rounded-full" data-id="element-348" />}
    </button>;
}